// src/contexts/AuthContext.js
import { createContext, useEffect, useReducer } from "react";

export const AuthContext = createContext();

const authReducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      return { user: action.payload };
    case "LOGOUT":
      return { user: null };
      // 🟢 NEW: Add this case to handle settings/profile updates smoothly
    case "UPDATE_USER":
      return { user: { ...state.user, ...action.payload } };
    default:
      return state;
  }
};

export function AuthContextProvider({ children }) {
  const [state, dispatch] = useReducer(authReducer, { user: null });

  // Load user from localStorage on first mount
  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (!stored) return;

    try {
      const parsed = JSON.parse(stored);
      if (parsed && parsed.token) {
        dispatch({ type: "LOGIN", payload: parsed });
      }
    } catch (err) {
      console.error("Failed to parse stored user", err);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, dispatch }}>
      {children}
    </AuthContext.Provider>
  );
}
